import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom';
import { useEntitiesByQuery } from 'hamster-react';
import { Offer } from 'cityads-v3/types/offers'
import { GoogleAdsIntegration, GoogleAdsAccount } from 'cityads-v3/types/googleAds';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip'
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

type IntegrationButtonProps = {
  offerId: Offer['id']
}

const IntegrationButton: React.FC<IntegrationButtonProps> = function ({ offerId }) {
  const { t } = useTranslation(['Offers'])

  const integrationsQuery = useMemo(() => offerId ? { offer_ids: offerId } : null, [offerId]);
  const [integrationsLoading, , integrations] = useEntitiesByQuery('googleAdsIntegration', integrationsQuery) as [boolean, boolean, GoogleAdsIntegration[] | null];

  const adsAccountsQuery = useMemo(
    () => integrations?.length
      ? { ids: integrations.map(integration => integration.google_ads_account_id) }
      : null,
    [integrations]
  );
  const [adsAccountsLoading, , adsAccounts] = useEntitiesByQuery('googleAdsAccount', adsAccountsQuery) as [boolean, boolean, GoogleAdsAccount[] | null];

  return (
    <WaitingButton
      component={Link}
      startIcon={integrations?.length ? <CheckOutlinedIcon /> : null}
      endIcon={<Tooltip title={integrations?.length ? t('exports.integrated') : t('exports.notIntegrated')}><InfoOutlinedIcon /></Tooltip>}
      to={integrations?.length ?
        `/publisher/tools/googleAdsIntegration?integration=${integrations[0].id}&account=${adsAccounts?.[0]?.google_account_id}` :
        `/publisher/tools/googleAdsIntegration/create?offerIds=${offerId}`
      }
      waiting={integrationsLoading || adsAccountsLoading}
    >
      {t('exports.googleAdsIntegration')}
    </WaitingButton>
  )
}

export default IntegrationButton;
